(ns app.front.ui.icon-button
  (:require [app.front.util :as futil]
            [core.front.carbon :as cc]))

(defn icon-button
  "A button composed of a single icon

  Props:
  `:icon`        icon, from `i/icons`
  `:description` string, the hover text for the icon
  `:on-click`    fn, no parameters
  `:disabled?`   boolean, default false
  `:class`       string, css classes for the button
  `:class-name`  string, css classes for the button
  `:fill`        string, fill color for the icon, default black"
  [{:keys [icon description on-click disabled? class class-name fill]}]
  (let [fill (or fill "black")]
    [:button.bg-transparent.border-0
     {:on-click on-click
      :disabled disabled?
      :class    (futil/cs (when disabled? "opacity-25")
                          "hover:bg-gray-400"
                          class-name
                          class)}
     (cc/icon {:icon        icon
               :description description
               :fill        fill})]))
